<template>
  <div class="specialtylife">
    <div class="header-specialtylife">
      <h4>{{ content_title }}</h4>
    </div>
    <div class="content-specialtylife">
      <span class="scroll" v-html="content_description"> </span>
    </div>
    <div class="btns-specialtylife">
      <div class="btn-view" style="text-align: center;" @click="GoSection()">
        <span>{{ checkISSection }}</span>
      </div>
      <div
        class="btn-payment"
        style="text-align: center;"
        v-if="checkISPayment"
        @click="Payment()"
      >
        <span>
          پرداخت کامل {{ convertTo(content_sell_price) }} {{ hzr }} تومان</span
        >
      </div>
      <router-link
        :to="{
          name: 'opinion',
          query: { id: this.id, content_title: content_title },
        }"
        class="btn-opinion"
      >
        <span> تجربه شرکت کنندگان</span>
      </router-link>
    </div>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "specialtylife",
  data() {
    return {
      id: "",
      content_description: "",
      checkISPayment: false,
      paylink: "",
      checkISSection: "",
      content_type: "",
      content_title: "",
      data: null,
      session_type: false,
      content_sell_price: "",
      hzr: "",
    };
  },
  methods: {
    convertTo(content_sell_price) {
      let price;
      if (content_sell_price >= 1000000) {
        this.hzr = "";
        price = content_sell_price;
      } else {
        price = content_sell_price / 1000;
        this.hzr = "هزار";
      }
      return parseInt(price)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    Payment() {
      this.$router.push({ name: "payment", query: { id: this.id } });
    },
    checkFavorite() {
      this.like =
        this.data.stats != null &&
        this.data.stats.record_favorite != null &&
        this.data.stats.record_favorite;
      if (this.like) {
        this.$root.$emit("fave_true");
      } else {
        this.$root.$emit("fave_false");
      }
    },
    getDatafav(response) {
      if (
        this.data.stats != null &&
        this.data.stats.record_favorite != null &&
        this.data.stats.record_favorite
      ) {
        this.data.stats.record_favorite = false;
      } else {
        if (this.data.stats == null) {
          this.data.stats = {};
        }
        this.data.stats.record_favorite = true;
      }
      this.checkFavorite();
    },
    getData(response) {
      this.data = response.data;
      this.content_sell_price = response.data.content_sell_price;
      this.content_description = response.data.content_description;
      if (!response.data.accessible && response.data.content_sell_price > 0) {
        this.checkISPayment = true;
      } else {
        this.checkISPayment = false;
      }
      if (
        response.data.content_type == 2 &&
        response.data.content_sub_sell != null &&
        response.data.content_sub_sell
      ) {
        this.checkISSection = "مشاهده بخش ها";
        //بخش
      } else {
        this.session_type = true;
        this.checkISSection = "مشاهده جلسات";
        //جلسه
      }
      this.content_type = response.data.content_type;
      this.content_sub_sell = response.data.content_sub_sell;
      this.content_title = response.data.content_title;
      this.$root.$emit("content_title", this.content_title);
      this.checkFavorite();
    },

    GoSection() {
      if (this.session_type == true) {
        this.$router.push({
          name: "meeting",
          query: {
            session_type: true,
            content_title: this.content_title,
            content_type: this.content_type,
            content_sub_sell: this.content_sub_sell,
            content_id: this.id,
          },
        });
      } else {
        this.$router.push({
          name: "meeting",
          query: {
            session_type: false,
            content_title: this.content_title,
            content_type: this.content_type,
            content_sub_sell: this.content_sub_sell,
            content_id: this.id,
          },
        });
      }
    },
  },
  mounted() {
    if (!oracle.isMobile()) {
      this.$root.$emit("BIGScreen");
    }
    this.id = this.$route.query.id;
    oracle.axios("content/getOne", { content_id: this.id }, this.getData);
    this.$root.$on("fave", () => {
      let like;
      if (
        this.data.stats != null &&
        this.data.stats.record_favorite != null &&
        this.data.stats.record_favorite
      ) {
        like = true;
      } else {
        like = false;
      }
      oracle.axios(
        "content/setState",
        { content_id: this.id, record_favorite: !like },
        this.getDatafav
      );
    });
  },
};
</script>
<style>
.scroll {
  /*display: flex;*/
  /*overflow: scroll;*/
  white-space: pre-line !important;
  word-wrap: break-word;
  padding-bottom: 30px;
  font-size: 12px;
}

.specialtylife {
  background-image: url("../../assets/image/background.jpg");
  height: 100%;
  position: relative;
  background-size: cover;
  padding: 0;
  z-index: 10;
  overflow: auto;
}

.content-specialtylife {
  height: 80vh;
  overflow: auto;
  background: rgba(255, 255, 255, 0.5);
  margin: 75px 20px;
  padding: 85px 20px;
}

.content-specialtylife h6 {
  font-size: 15px;
  font-weight: 100;
  padding: 10px;
}

.content-specialtylife p {
  font-size: 15px;
  padding-right: 10px;
  padding-top: 15px;
}

.content-specialtylife ul li {
  font-size: 14px;
  padding-right: 40px;
  line-height: 2;
}

.btns-specialtylife .btn-view,
.btns-specialtylife .btn-payment,
.btns-specialtylife .btn-opinion {
  align-items: center;
  display: flex;
  color: #fff;
  margin: 0 4px 0 4px;
  padding: 2px;
  font-size: 13px;
}

.btns-specialtylife {
  display: flex;
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
  align-content: center;
  justify-content: center;
}

.btns-specialtylife .btn-view {
  background: #0000cd;
  border-radius: 5px;
}

.btns-specialtylife .btn-payment {
  background: #50ac17;
  border-radius: 5px;
}

.btns-specialtylife .btn-opinion {
  background: #8f14c4;
  border-radius: 5px;
}

.btns-specialtylife a span {
  display: flex;
  text-align: center;
  padding: 10px;
}
.header-specialtylife {
  position: absolute;
  top: 22px;
  left: 0;
  right: 0;
  padding-right: 70px;
  margin: auto;
  display: flex;
  align-items: center;
  color: #0000cd;
}
.header-specialtylife h4 {
  font-size: 13px;
}
</style>
